import script from "./ReviewEditFormModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ReviewEditFormModal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__